"use client"

import { useStepperContext } from '@/shared/context/stepper-context'
import React from 'react'
import HomeOwnerForm from './home-owner-form'
import HomeOwnerWithHomeFormNavigator from '../home-owner-with-home-form-navigator'

function HomeWithHomeOwnerForm() {
    const { 
        currentStep, 
    } = useStepperContext()

    return (
        <div className='flex flex-col gap-8'>
            {currentStep.number === 1 && <HomeOwnerForm />}
            
            <HomeOwnerWithHomeFormNavigator />
        </div>
    )
}

export default HomeWithHomeOwnerForm
